package team.platforma.multiplatform_material_extension.ui.theme

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.State
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import team.platforma.multiplatform_material_extension.isDarkTheme


object Theme {
    private val _isDarkTheme: MutableStateFlow<Boolean> = MutableStateFlow(false)
    internal val isDark: StateFlow<Boolean> = _isDarkTheme

    fun setDarkTheme(isDarkTheme: Boolean) {
        _isDarkTheme.value = isDarkTheme
    }

}
@Composable
fun Theme.isDark(): Boolean {
   return this.isDark.collectAsState().value
}

@Composable
fun rememberTheme(autoSwitch: Boolean = false): Theme  {
    val initDarkTheme = isDarkTheme()

    if (autoSwitch) {
        LaunchedEffect(initDarkTheme) {
            Theme.setDarkTheme(initDarkTheme)
        }
    } else {
        LaunchedEffect(Unit) {
            Theme.setDarkTheme(initDarkTheme)
        }
    }

    return Theme
}